export const INVENTORY_DND_TYPE = 'inventory';
export const WAREHOUSE_DND_TYPE = 'warehouse';
export const INVENTORY_DROPZONE_DND_TYPE = 'inventory-dropzone';

export const getWarehouseSortableId = (warehouseId: number) => `warehouse:${warehouseId}`;

export const getInventorySortableId = (inventoryGuid: string) => `inventory:${inventoryGuid}`;

export const getInventoryDropzoneId = (warehouseId: number) => `inventory-dropzone:${warehouseId}`;

export const getInventoryInsertIndex = ({
    activeIndex,
    overIndex,
    overWarehouseItemsCount,
    isSameWarehouse,
    isAfterOverItem,
}: {
    activeIndex: number;
    overIndex?: number;
    overWarehouseItemsCount: number;
    isSameWarehouse: boolean;
    isAfterOverItem: boolean;
}) => {
    const maxInsertIndex = Math.max(
        0,
        overWarehouseItemsCount - (isSameWarehouse && activeIndex !== -1 ? 1 : 0)
    );

    if (typeof overIndex === 'undefined') {
        return maxInsertIndex;
    }

    const nextIndex = overIndex + (isAfterOverItem ? 1 : 0);
    const adjustedIndex =
        isSameWarehouse && activeIndex !== -1 && activeIndex < nextIndex
            ? nextIndex - 1
            : nextIndex;

    return Math.min(Math.max(adjustedIndex, 0), maxInsertIndex);
};

export const getInventoryPreviewIndex = ({
    overIndex,
    overWarehouseItemsCount,
    isSameWarehouse,
    isAfterOverItem,
}: {
    overIndex?: number;
    overWarehouseItemsCount: number;
    isSameWarehouse: boolean;
    isAfterOverItem: boolean;
}) => {
    if (isSameWarehouse) {
        const maxIndex = Math.max(0, overWarehouseItemsCount - 1);

        if (typeof overIndex === 'undefined') {
            return maxIndex;
        }

        return Math.min(Math.max(overIndex, 0), maxIndex);
    }

    return getInventoryInsertIndex({
        activeIndex: -1,
        overIndex,
        overWarehouseItemsCount,
        isSameWarehouse: false,
        isAfterOverItem,
    });
};

export interface WarehouseDragData {
    type: typeof WAREHOUSE_DND_TYPE;
    warehouseId: number;
}

export interface InventoryDragData {
    type: typeof INVENTORY_DND_TYPE;
    inventoryGuid: string;
    warehouseId: number;
}

export interface InventoryDropzoneDragData {
    type: typeof INVENTORY_DROPZONE_DND_TYPE;
    warehouseId: number;
}

export type EquipmentDragData = WarehouseDragData | InventoryDragData | InventoryDropzoneDragData;
